import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_SALARIES_DATA_SAGA } from "../sagaTypes";
import { loaderAction, setSalariesDataAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/get_salaries`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetSalaries(args) {
    const user = yield select(state => state.user);
    const currentEstablishment = yield select(state => state.currentEstablishment);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('establishment', currentEstablishment);
        formData.append('date_from', args.data?.date_from || '');
        formData.append('date_to', args.data?.date_to || '');
        formData.append('coach_workout_cost', args.data?.coach_workout_cost || '0');
        formData.append('coach_client_cost', args.data?.coach_client_cost || '0');
        formData.append('workouts_types_cost', args.data?.workouts_types_cost);
        formData.append('consider_subscription_cost', args.data?.consider_subscription_cost || '0');
        formData.append('consider_subscription_percent', args.data?.consider_subscription_percent || '0');
        formData.append('one_time_percent', args.data?.one_time_percent || '0');

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            yield put(setSalariesDataAction(response.salaries));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherGetSalaries() {
    yield takeLatest(GET_SALARIES_DATA_SAGA, workerGetSalaries);
}